module.exports = __webpack_public_path__ + "media/images/fitness-77b3dc09077b87083bf40c3fdbe55928.svg";